import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { useAdditionalAnalyticsLicenseCountCostForBillingPlanId } from '../../../../hooks/use-plan-details';

import { messages } from './messages';

import style from '../plan-details.module.less';

type AnalyticsLicenseCostProps = {
  billingPlanId: string;
  additionalLicenses: number;
};

export const AnalyticsLicenseCost = ({ billingPlanId, additionalLicenses }: AnalyticsLicenseCostProps) => {
  const cost = useAdditionalAnalyticsLicenseCountCostForBillingPlanId(billingPlanId, additionalLicenses);

  const message = cost?.value ? (
    <FormattedMessage
      {...messages.analyticsLicenseAdditionalCost}
      values={{
        cost: <FormattedCurrency currencyCode={cost?.code} value={cost.value} />,
      }}
    />
  ) : (
    <FormattedMessage {...messages.includedAbbreviation} />
  );

  return <Text className={style['plan-option-content-cost']} element='span' textType={TextType.Caption} value={message} />;
};
